<template>
    <div class="p-3 text-center">
        <img class="logo" :src="urlLogo" :title="titlePortal">
        <h4 class="text-center my-2">{{titlePortal}}</h4>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: 'Front-logo',
        data() {
			return {
				titulo: this.$Params.titulo,
                urlLogo: this.$Params.img_logo ? (this.$Params.urlBase + this.$Params.img_logo) : `${this.$Params.urlImages}logo`
            }
        },
        computed:{
            ...mapState(['titlePortal'])
        }
    }
</script>